import { Component, OnInit } from '@angular/core';
import { FoodPortalService } from './services/food-portal.service';
import { switchMap } from 'rxjs/operators';

@Component({
    selector: 'pi-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'FoodPortal';
  initialised = false;

  constructor(private svc: FoodPortalService) {

  }

  ngOnInit() {
    this.svc.getPortalSettings().pipe(
      switchMap(() => {
        return this.svc.getRecipes();
      })
    ).subscribe(e => {
      this.initialised = true;
    });
  }

}
